import { render } from "./ConfigRound.vue?vue&type=template&id=430e9d34"
import script from "./ConfigRound.vue?vue&type=script&lang=js"
export * from "./ConfigRound.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__